/*!
 * © 2026 Soulcute / Tailoring Consult — Todos los derechos reservados.
 * Código propietario. Prohibida su reproducción o redistribución sin autorización expresa.
 * Contacto: administracion@tailoringconsult.com
 */
/* Cart Rewards — auto-add/remove gifts cuando cart cruza thresholds */
(function(){
  var cfg=window.scRewardsCfg;
  if(!cfg)return;
  var GP=cfg.giftProperty||'_sc_gift';
  var syncing=false;

  function cartSubtotalWithoutGifts(cart){
    var sub=0;
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(p[GP])return;
      sub+=(it.final_line_price!=null?it.final_line_price:it.line_price);
    });
    return sub;
  }

  function findGiftLine(cart,handle){
    return (cart.items||[]).find(function(it){
      var p=it.properties||{};
      return it.handle===handle&&p[GP];
    });
  }

  function addGift(variantId){
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({items:[{id:variantId,quantity:1,properties:{[GP]:'true'}}]})
    }).then(function(r){var resp=r;triggerCartRefresh();return resp;});
  }

  /* Dispara el evento que Horizon escucha para re-renderizar el cart drawer/page.
     Sin esto, los cambios via /cart/* requieren refresh de página para verse. */
  function triggerCartRefresh(){
    /* Pequeño delay para asegurar que el cart-side ya procesó el cambio */
    setTimeout(function(){
      document.dispatchEvent(new CustomEvent('cart:update',{
        bubbles:true,
        detail:{resource:{},data:{source:'sc-rewards',sections:{}}}
      }));
    },150);
  }

  /* Detecta la talla más frecuente del cart (excluyendo regalos) y devuelve el variantId
     correspondiente del gift que matchee esa talla. Si no hay match, devuelve el default. */
  function pickGiftVariantBySize(cart, giftCfg){
    if(!giftCfg.variants || !giftCfg.variants.length) return giftCfg.variantId;
    var counts={};
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(p[GP]) return;  /* skip gifts */
      var opts=it.options_with_values||[];
      opts.forEach(function(o){
        var name=(o.name||'').toLowerCase();
        if(name==='talla'||name==='size'){
          var v=String(o.value||'').toUpperCase();
          counts[v]=(counts[v]||0)+1;
        }
      });
    });
    var topSize=null,topCount=0;
    for(var k in counts){if(counts[k]>topCount){topCount=counts[k];topSize=k;}}
    if(!topSize) return giftCfg.variantId;  /* default M */
    var match=giftCfg.variants.find(function(v){return String(v.title).toUpperCase()===topSize});
    return match?match.id:giftCfg.variantId;
  }

  /* Stock check del producto REAL (e.g. PANTY CONTROL CHIC).
     Devuelve un mapa { sizeTitle: true|false } y un boolean global.
     Cache 30s para no spamear /products/X.js durante el polling. */
  var _stockCache={};
  function realProductStock(handle){
    if(!handle) return Promise.resolve({has:true,bySize:{}});
    var c=_stockCache[handle];
    if(c && (Date.now()-c.ts)<30000) return Promise.resolve(c.value);
    return fetch('/products/'+handle+'.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(product){
        var bySize={};
        (product.variants||[]).forEach(function(v){
          /* Buscar valor de talla en options o title */
          var size=null;
          if(v.options&&v.options.length){
            /* Si el producto tiene 1 sola opción (Talla), v.options[0] es la talla */
            size=String(v.options[v.options.length-1]).toUpperCase();
          } else if(v.title){
            size=String(v.title).toUpperCase();
          }
          if(size)bySize[size]=v.available===true;
        });
        var has=Object.keys(bySize).some(function(k){return bySize[k]});
        var res={has:has,bySize:bySize};
        _stockCache[handle]={ts:Date.now(),value:res};
        return res;
      })
      .catch(function(){return {has:true,bySize:{}}});  /* fallar abierto */
  }
  /* Wrapper backwards-compatible */
  function realProductHasStock(handle){
    return realProductStock(handle).then(function(r){return r.has});
  }

  function removeGiftLine(key){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({id:key,quantity:0})
    }).then(function(r){var resp=r;triggerCartRefresh();return resp;});
  }

  /* Cap gift line quantity a 1: si cliente clickea + en el carrito, revierte */
  function capGiftQuantity(key){
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({id:key,quantity:1})
    }).then(function(r){var resp=r;triggerCartRefresh();return resp;});
  }

  /* Lock para evitar race condition durante cambio de talla del regalo:
     remove→add NO debe ser interrumpido por polling/auto-sync que detecta "no hay regalo"
     y agrega uno default antes de que termine el cambio. */
  var _sizeChangeLock=false;

  function syncOnce(){
    if(syncing||_sizeChangeLock){console.log('[sc-rewards] skip sync — busy or size-change in progress');return Promise.resolve();}
    syncing=true;
    return fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(cart){
        var sub=cartSubtotalWithoutGifts(cart);
        console.log('[sc-rewards] sync — sub:',sub,'cart items:',cart.items.length);
        var promises=[];
        ['gift1','gift2'].forEach(function(key){
          var g=cfg[key];
          if(!g||!g.enabled){console.log('[sc-rewards]',key,'disabled');return;}
          if(!g.variantId){console.warn('[sc-rewards]',key,'sin variantId — saltando auto-add');return;}
          if(!g.handle){console.warn('[sc-rewards]',key,'sin handle — saltando');return;}
          var existing=findGiftLine(cart,g.handle);
          var shouldHave=sub>=g.threshold;
          /* Detectar duplicados (más de 1 línea del mismo gift handle) y eliminar extras */
          var allLines=(cart.items||[]).filter(function(it){
            var p=it.properties||{};
            return it.handle===g.handle&&p[GP];
          });
          if(allLines.length>1){
            console.log('[sc-rewards]',key,'detectados',allLines.length,'duplicados — limpiando extras');
            allLines.slice(1).forEach(function(extra){
              promises.push(removeGiftLine(extra.key).catch(function(e){console.error('[sc-rewards] remove duplicate error',e)}));
            });
          }
          console.log('[sc-rewards]',key,'threshold:',g.threshold,'shouldHave:',shouldHave,'existing:',!!existing);
          if(shouldHave&&!existing){
            /* Si hay realProductHandle, validar stock del producto REAL antes de agregar el regalo */
            promises.push(realProductHasStock(g.realProductHandle).then(function(hasStock){
              if(!hasStock){
                console.log('[sc-rewards]',key,'real product sin stock — saltando auto-add silencioso');
                return;
              }
              /* Pick best variant by detected size from cart (sólo para gift1) */
              var vid=(key==='gift1')?pickGiftVariantBySize(cart,g):g.variantId;
              console.log('[sc-rewards] addGift',vid,'(picked from size detection)');
              return addGift(vid).then(function(r){return r.json()}).then(function(j){
                console.log('[sc-rewards] add response',j);
              }).catch(function(e){console.error('[sc-rewards] addGift error',e)});
            }));
          }else if(!shouldHave&&existing){
            console.log('[sc-rewards] removeGift',existing.key);
            promises.push(removeGiftLine(existing.key).catch(function(e){console.error('[sc-rewards] remove error',e)}));
          }else if(shouldHave&&existing&&existing.quantity>1){
            /* Cliente intentó sumar el regalo — capar a 1 */
            console.log('[sc-rewards]',key,'gift quantity>1 (' + existing.quantity + ') — capando a 1');
            promises.push(capGiftQuantity(existing.key).catch(function(e){console.error('[sc-rewards] cap error',e)}));
          }
        });
        return Promise.all(promises);
      })
      .then(function(){
        syncing=false;
        /* Si hicimos cambios, recargar para refrescar UI de cart */
        /* Solo recargar si estamos en /cart page (no en drawer) */
        if(window.location.pathname==='/cart'){
          /* Verificar si hubo cambios consultando cart de nuevo - si difiere de antes, reload */
          /* Por simplicidad, solo reload si page de cart y solo si pasamos algún threshold */
        }
      })
      .catch(function(){syncing=false});
  }

  /* ========================================
     Bloqueo visual: ocultar +/-/delete en líneas de regalo
     ======================================== */
  function injectGiftStyles(){
    if(document.getElementById('sc-gift-lock-styles'))return;
    var s=document.createElement('style');
    s.id='sc-gift-lock-styles';
    s.textContent=[
      /* Distintivo sutil de la línea de regalo */
      '.sc-is-gift { position:relative; }',
      /* Ocultar quantity controls + remove button */
      '.sc-is-gift quantity-input,',
      '.sc-is-gift .quantity,',
      '.sc-is-gift .quantity-selector,',
      '.sc-is-gift [name="updates[]"],',
      '.sc-is-gift button[name="minus"],',
      '.sc-is-gift button[name="plus"],',
      '.sc-is-gift button[name="decrease"],',
      '.sc-is-gift button[name="increase"],',
      '.sc-is-gift [data-quantity-decrease],',
      '.sc-is-gift [data-quantity-increase],',
      '.sc-is-gift cart-remove-button,',
      '.sc-is-gift [data-line-item-remove],',
      '.sc-is-gift button[aria-label*="remove" i],',
      '.sc-is-gift button[aria-label*="quitar" i],',
      '.sc-is-gift button[aria-label*="eliminar" i],',
      '.sc-is-gift button[aria-label*="delete" i],',
      '.sc-is-gift .cart-item__quantity-wrapper,',
      '.sc-is-gift .cart-item__quantity { display:none !important; visibility:hidden !important }',
      /* Wrapper para badge + dropdown — reemplaza el espacio de qty controls */
      '.sc-gift-meta { display:inline-flex; flex-wrap:wrap; align-items:center; gap:10px; margin-top:6px; }',
      /* Badge tipo "tag" compacto y elegante (no domina visualmente) */
      '.sc-gift-badge { display:inline-flex; align-items:center; gap:4px; font-size:11px; font-weight:700; color:#fff; background:linear-gradient(135deg,#E91E63 0%,#6B031E 100%); padding:4px 10px; border-radius:14px; letter-spacing:.02em; text-transform:uppercase; box-shadow:0 1px 3px rgba(107,3,30,.2); line-height:1; }',
      /* Dropdown de cambio de talla — estilo Horizon-like */
      '.sc-gift-size-selector { display:inline-flex; align-items:center; gap:6px; font-size:13px; color:#6B031E; font-family:inherit; }',
      '.sc-gift-size-selector__label { font-size:12px; font-weight:600; color:#666; }',
      '.sc-gift-size-selector select { appearance:none; -webkit-appearance:none; padding:5px 26px 5px 10px; border:1.5px solid #D8A7B1; border-radius:6px; background:#fff url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 12 12\' fill=\'%236B031E\'%3e%3cpath d=\'M2 4l4 4 4-4\' stroke=\'%236B031E\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3e%3c/svg%3e") no-repeat right 8px center; background-size:10px; color:#6B031E; font-weight:700; cursor:pointer; min-width:70px; font-size:13px; line-height:1.2; transition:all .15s ease; }',
      '.sc-gift-size-selector select:hover { border-color:#6B031E; }',
      '.sc-gift-size-selector select:disabled { opacity:.5; cursor:wait; }',
      '.sc-gift-size-selector select:focus { outline:none; border-color:#6B031E; box-shadow:0 0 0 3px rgba(107,3,30,.12); }',
      /* Precio inline duplicado ($0 debajo del título) — clase exacta de Horizon */
      '.sc-is-gift .cart-items__unit-price-wrapper,',
      '.sc-is-gift .cart-item__price-wrapper,',
      '.sc-is-gift .cart-item__details .cart-item__price,',
      '.sc-is-gift .cart-item__info .cart-item__price { display:none !important; visibility:hidden !important; }',
      /* También ocultar el TD entero de precio unitario si está vacío */
      '.sc-is-gift td:has(.cart-items__unit-price-wrapper) { padding:0 !important; }',
      /* El line-total (a la derecha) en fucsia para destacar */
      '.sc-is-gift .cart-items__line-price,',
      '.sc-is-gift .cart-item__line-price,',
      '.sc-is-gift [class*="line-price"] { color:#E91E63 !important; font-weight:700 !important; }',
      /* Cart drawer popup: backdrop transparente (se ve la página detrás) */
      'cart-drawer-component dialog::backdrop { background:transparent !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }',
      'dialog.cart-drawer__dialog::backdrop { background:transparent !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }',
      /* Asegurar que el dialog en sí tenga sombra propia para distinguirse */
      'cart-drawer-component dialog.cart-drawer__dialog { box-shadow:-8px 0 32px rgba(107,3,30,.18) !important; }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function tagGiftLines(){
    injectGiftStyles();
    var giftVids=[];
    var giftVidToCfg={};
    if(cfg.gift1){
      if(cfg.gift1.variants&&cfg.gift1.variants.length){
        cfg.gift1.variants.forEach(function(v){
          giftVids.push(String(v.id));
          giftVidToCfg[String(v.id)]={key:'gift1',cfg:cfg.gift1,size:v.title};
        });
      }else if(cfg.gift1.variantId){
        giftVids.push(String(cfg.gift1.variantId));
        giftVidToCfg[String(cfg.gift1.variantId)]={key:'gift1',cfg:cfg.gift1,size:null};
      }
    }
    if(cfg.gift2&&cfg.gift2.variantId){
      giftVids.push(String(cfg.gift2.variantId));
      giftVidToCfg[String(cfg.gift2.variantId)]={key:'gift2',cfg:cfg.gift2,size:null};
    }
    if(!giftVids.length)return;

    document.querySelectorAll('[data-variant-id]').forEach(function(el){
      var vid=String(el.dataset.variantId);
      if(giftVids.indexOf(vid)<0)return;
      var row=el.closest('cart-items-component li, cart-items-component tr, [data-line-item], .cart-item, [class*="cart-item__row"], li[id*="CartItem"]')||el.parentElement;
      if(!row||row.classList.contains('sc-is-gift'))return;
      row.classList.add('sc-is-gift');
      var info=giftVidToCfg[vid];
      injectGiftMeta(row,info,el);
    });
  }

  function injectGiftMeta(row,info,variantEl){
    if(row.querySelector('.sc-gift-meta'))return;
    var meta=document.createElement('div');
    meta.className='sc-gift-meta';
    /* Badge — siempre presente */
    var badge=document.createElement('span');
    badge.className='sc-gift-badge';
    badge.innerHTML='\u{1F381} Regalo gratis';
    meta.appendChild(badge);
    /* Dropdown — solo si gift1 con tallas */
    if(info.key==='gift1'&&info.cfg.variants&&info.cfg.variants.length>1){
      var sel=buildSizeSelector(info.cfg,info.size);
      meta.appendChild(sel);
    }
    var insertTarget=row.querySelector('.cart-item__details, .cart-item__info, .cart-item__media')||row;
    insertTarget.appendChild(meta);
  }

  function buildSizeSelector(giftCfg,currentSize){
    var wrap=document.createElement('span');
    wrap.className='sc-gift-size-selector';
    var lbl=document.createElement('span');
    lbl.className='sc-gift-size-selector__label';
    lbl.textContent='Talla:';
    var sel=document.createElement('select');
    /* Placeholder de "cargando..." mientras consulta stock real */
    var loading=document.createElement('option');
    loading.textContent='...';loading.disabled=true;loading.selected=true;
    sel.appendChild(loading);

    /* Filtrar variants solo a las que tengan stock en el PANTY REAL */
    realProductStock(giftCfg.realProductHandle).then(function(stock){
      sel.innerHTML='';
      var available=giftCfg.variants.filter(function(v){
        var sz=String(v.title).toUpperCase();
        return stock.bySize[sz]===true;
      });
      /* Si la API no devolvió data o no hay sizes con stock, mostrar todas (fail-open) */
      var list=available.length?available:giftCfg.variants;
      list.forEach(function(v){
        var opt=document.createElement('option');
        opt.value=v.id;
        opt.textContent=v.title;
        if(String(v.title).toUpperCase()===String(currentSize||'').toUpperCase())opt.selected=true;
        sel.appendChild(opt);
      });
    });
    sel.addEventListener('change',function(){
      var newVid=parseInt(sel.value);
      if(!newVid)return;

      /* UI OPTIMISTA: dropdown queda en nuevo valor inmediato + badge "Actualizando..." */
      _sizeChangeLock=true;
      sel.disabled=true;
      var row=sel.closest('.sc-is-gift');
      var badge=row?row.querySelector('.sc-gift-badge'):null;
      var originalBadge=badge?badge.innerHTML:'';
      if(badge)badge.innerHTML='\u{1F504} Actualizando...';

      function releaseLock(){
        _sizeChangeLock=false;
        sel.disabled=false;
        if(badge)badge.innerHTML=originalBadge;
      }

      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
        var allGiftLines=(cart.items||[]).filter(function(it){
          var p=it.properties||{};
          return it.handle===giftCfg.handle&&p[GP];
        });
        if(!allGiftLines.length){
          return addGift(newVid).then(function(){setTimeout(releaseLock,600);});
        }
        var chain=Promise.resolve();
        allGiftLines.forEach(function(line){chain=chain.then(function(){return removeGiftLine(line.key)});});
        return chain.then(function(){return addGift(newVid);}).then(function(){
          setTimeout(releaseLock,600);
        });
      }).catch(function(e){console.error('[sc-rewards] size change error',e);releaseLock();});
    });
    wrap.appendChild(lbl);
    wrap.appendChild(sel);
    return wrap;
  }

  /* Re-tag cuando cambie el DOM del cart drawer/page */
  var giftTagObserver=null;
  function startGiftTagObserver(){
    if(giftTagObserver)return;
    giftTagObserver=new MutationObserver(function(){tagGiftLines()});
    giftTagObserver.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){tagGiftLines();startGiftTagObserver()});
  }else{
    tagGiftLines();startGiftTagObserver();
  }

  /* Interceptar fetches a /cart/* */
  var origFetch=window.fetch;
  window.fetch=function(){
    var args=arguments;
    var url=args[0];
    var promise=origFetch.apply(this,args);
    if(typeof url==='string'&&(/\/cart\/(add|change|update|clear)/.test(url))){
      promise.then(function(){
        setTimeout(syncAndMaybeReload,400);
      }).catch(function(){});
    }
    return promise;
  };

  /* Interceptar XMLHttpRequest (algunos themes lo usan en vez de fetch) */
  var origOpen=XMLHttpRequest.prototype.open;
  var origSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(method,url){
    this.__sc_url=url;
    return origOpen.apply(this,arguments);
  };
  XMLHttpRequest.prototype.send=function(){
    var xhr=this;
    if(typeof xhr.__sc_url==='string'&&/\/cart\/(add|change|update|clear)/.test(xhr.__sc_url)){
      xhr.addEventListener('load',function(){setTimeout(syncAndMaybeReload,400)});
    }
    return origSend.apply(this,arguments);
  };

  /* Listen Shopify theme events */
  ['cart:updated','cart:added','cart:changed','cart:item-added','cart:refresh','variant:add'].forEach(function(ev){
    document.addEventListener(ev,function(){setTimeout(syncAndMaybeReload,400)});
    window.addEventListener(ev,function(){setTimeout(syncAndMaybeReload,400)});
  });

  /* Poll fallback cada 3s (solo cuando ventana visible) */
  setInterval(function(){
    if(document.visibilityState==='visible'&&!syncing){
      syncAndMaybeReload();
    }
  },3000);

  var lastSubtotal=null;
  function syncAndMaybeReload(){
    var oldSub=lastSubtotal;
    fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(cart){
        var sub=cartSubtotalWithoutGifts(cart);
        var crossedThreshold=false;
        if(oldSub!==null){
          ['gift1','gift2'].forEach(function(key){
            var g=cfg[key];
            if(!g||!g.enabled)return;
            var was=oldSub>=g.threshold;
            var now=sub>=g.threshold;
            if(was!==now)crossedThreshold=true;
          });
        }
        lastSubtotal=sub;
        return syncOnce().then(function(){
          if(crossedThreshold&&window.location.pathname==='/cart'){
            /* Reload para mostrar nueva barra + gift en cart */
            window.location.reload();
          }
        });
      });
  }

  /* Sync inicial al cargar */
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
    lastSubtotal=cartSubtotalWithoutGifts(cart);
    syncOnce();
  });
})();
